// eslint-disable-next-line no-restricted-imports
import { ThemeProvider as EmotionThemeProvider } from "@emotion/react";
import * as React from "react";

import {
  defaultTheme,
  darkTheme,
  DefaultTheme,
} from "@brexhq/shared/styles/theming";

export const ThemeProvider: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  return (
    <EmotionThemeProvider theme={defaultTheme}>{children}</EmotionThemeProvider>
  );
};

const overwrittenBreakpoints = {
  SML: "@media(max-width: 830px)",
};

/**
Wrap a module with this to adjust the breakpoints, it must go INSIDE ModuleLayout as to not overwrite the visibility breakpoints.

 * @param  {breakpoints} - partial object of breakpoint values to overwrite

 * Current breakpoints: {@link defaultTheme.breakpoints.LRG}
 */
export const CustomBreakpoints: React.FC<
  React.PropsWithChildren<{
    breakpoints?: Partial<DefaultTheme["breakpoints"]>;
  }>
> = ({ children, breakpoints = overwrittenBreakpoints }) => {
  return (
    <EmotionThemeProvider
      theme={{
        ...defaultTheme,
        breakpoints: { ...defaultTheme.breakpoints, ...breakpoints },
      }}
    >
      {children}
    </EmotionThemeProvider>
  );
};

/**
Wrap a metal component with this to override to use dark theme.  Each component must be wrapped individually.
 */
export const DarkModeOverride: React.FC<
  React.PropsWithChildren<{
    useDarkMode: boolean;
  }>
> = ({ useDarkMode, children }) => {
  const theme = useDarkMode ? darkTheme : defaultTheme;

  return <EmotionThemeProvider theme={theme}>{children}</EmotionThemeProvider>;
};
